<template>
  <b-row>
    <b-col cols="12" sm="4" class="px-2"></b-col>
    <b-col cols="12" sm="4" class="px-2">
      <b-button
        variant="outline-secondary"
        class="bg-white text-danger"
        :style="'max-height: 64px; max-width: 220px; width: 100%'"
        @click="showDelFileRequest"
      >
        Delete
      </b-button>
    </b-col>
    <b-col cols="12" sm="4" class="px-2">
      <b-button
        variant="outline-secondary"
        class="bg-white text-dark"
        :style="'max-height: 64px; max-width: 220px; width: 100%'"
        @click="editFileRequest"
      >
        Edit
      </b-button>
    </b-col>

    <b-modal
      centered
      v-model="delModalShow"
      id="delete-request-modal"
      title="Delete file request?"
    >
      <p class="my-4">
        Are you sure you want to delete the file request?
      </p>

      <template #modal-footer>
        <b-button variant="secondary" @click="cancelDelFileRequest()">
          No, keep it.
        </b-button>
        <b-button variant="primary" @click="deleteFileRequest()">
          Yes, delete file request.
        </b-button>
      </template>
    </b-modal>
  </b-row>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    request: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      delModalShow: false
    }
  },

  methods: {
    ...mapActions({
      getRequestByUser: 'requests/getRequestByUser',
      deleteRequest: 'requests/deleteRequest'
    }),

    async editFileRequest() {
      this.$router.replace({
        name: 'request.edit-requested-to-page',
        params: {
          id: this.request.file_request_id
            ? this.request.file_request_id
            : this.request.id
            ? this.request.id
            : null
        }
      })
    },

    async deleteFileRequest() {
      this.$emit('showAlert', 'deleted')
      await this.deleteRequest(
        this.request.file_request_id
          ? this.request.file_request_id
          : this.request.id
          ? this.request.id
          : null
      ).then(() => {
        this.cancelDelFileRequest()
        this.$emit('showAlert', 'deleted')
      })
    },

    showDelFileRequest() {
      this.delModalShow = true
    },
    cancelDelFileRequest() {
      this.delModalShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .dropdown-menu {
  top: -15px !important;
  left: -20px !important;
}
.pin {
  width: 23px;
  height: 23px;
}
</style>
